import { useSelector } from 'app-redux'
import type { YouTubeStreamState } from 'features/youtube-streaming/model'
import { selectYouTubeStreamState } from 'features/youtube-streaming/youtube-streaming-redux'
import { extractYouTubeVideoId } from 'features/youtube-streaming/youtube-utils'
import { FC } from 'react'
import { useConsoleMedia } from './presenter-console'
import { VideoMonitor } from './presentation/video-monitor'
import { useMediaRemote } from './use-media-remote'
import { useVideoMonitor } from './use-video-monitor'

const Monitor: FC<{ stream: YouTubeStreamState }> = ({ stream }) => {
	const remote = useMediaRemote('youtube')
	const media = useConsoleMedia()
	const playerRef = useVideoMonitor(
		extractYouTubeVideoId(stream.link),
		media?.kind === 'youtube' ? media : null
	)

	return remote ? <VideoMonitor {...remote} playerRef={playerRef} /> : null
}

/**
 * The console's stand-in for the YouTube player while presenting
 * (`TrainerFocusedFeature`, surface `console`): the film plays - and sounds -
 * in the presentation window; here it is only watched, silent, with the
 * same commands under it as the player's own (`useMediaRemote`). The film
 * itself always fills the projector (`YouTubeStreamingTrainer`, surface
 * `projector`).
 */
export const ConfiguredVideoMonitor: FC = () => {
	const stream = useSelector(selectYouTubeStreamState)
	return stream ? <Monitor stream={stream} /> : null
}

export default ConfiguredVideoMonitor
